import { useRefreshTokenMutation } from '@/services/api.service';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { removeStorageItem } from '@/utils/localStorage';

import { useGamezone } from './useGamezone';
import { useJwt } from './useJwt';

export const clearAuthData = () => {
  // Do not remove refreshToken
  removeStorageItem(StorageKeysEnum.jwt);
  removeStorageItem(StorageKeysEnum.clientToken);
};

export const useLogout = () => {
  const { createGamezoneUrl } = useGamezone();
  const [triggerRefreshToken, { isLoading: isLoadingRefreshToken }] =
    useRefreshTokenMutation();
  const { setJwt, refreshToken, setRefreshToken } = useJwt();

  const redirectToLogin = () => {
    window.location.assign(createGamezoneUrl({ pathname: '/login' }));
  };

  // Make request to refresh token -> update auth data -> make submit
  const refreshAccessToken = async (props?: { onSuccess?: () => void }) => {
    const { onSuccess } = props || {};

    try {
      const refreshRes = await triggerRefreshToken({
        refreshToken: refreshToken,
      }).unwrap();
      setJwt(refreshRes.token);
      setRefreshToken(refreshRes.refresh_token);

      // Make submit
      onSuccess?.();
    } catch (error) {
      clearAuthData();
      redirectToLogin();
    }
  };

  return {
    clearAuthData,
    redirectToLogin,
    refreshAccessToken,
    isLoadingRefreshToken,
  };
};
